// Der Oelfinder im Kategorie-Header nimmt mobil fast einen ganzen Bildschirm ein.
// Dort wird er deshalb eingeklappt ausgeliefert; die Ueberschrift dient als Schalter.
// Das Markup kommt aus dem CMS (category_description_excerpt), der Schalter muss
// daher hier ergaenzt werden.
//
// Der Umbau passiert ausschliesslich unterhalb des Breakpoints und wird beim
// Wechsel auf Desktop vollstaendig zurueckgebaut - dort bleibt das Widget exakt
// so, wie es aus dem CMS kommt.

const BREAKPOINT = '(max-width: 767px)';

export function initOelfinderCollapse() {
    const widgets = document.querySelectorAll('.categoryInfo_excerpt .oelfinder-widget');
    if (!widgets.length) return;

    const mq = window.matchMedia(BREAKPOINT);

    widgets.forEach((widget, index) => {
        const content = widget.querySelector('.oelfinder-content');
        if (!content) return;

        let toggle = null;
        let body   = null;

        function setOpen(open) {
            widget.classList.toggle('is-open', open);
            if (toggle) toggle.setAttribute('aria-expanded', String(open));
        }

        function onToggle() {
            setOpen(!widget.classList.contains('is-open'));
        }

        function build() {
            if (toggle) return;

            body = document.createElement('div');
            body.className = 'oelfinder-widget__body';
            body.id = `oelfinderBody${index}`;
            // alles ausser der Ueberschrift wandert in den aufklappbaren Bereich
            while (content.nextSibling) body.appendChild(content.nextSibling);
            widget.appendChild(body);

            toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'oelfinder-widget__toggle';
            toggle.setAttribute('aria-controls', body.id);
            widget.insertBefore(toggle, content);
            toggle.appendChild(content);
            toggle.addEventListener('click', onToggle);

            widget.classList.add('oelfinder-widget--collapsible');
            setOpen(false);
        }

        function teardown() {
            if (!toggle) return;

            widget.classList.remove('oelfinder-widget--collapsible', 'is-open');
            // Ausgangszustand wiederherstellen: erst die Ueberschrift, dann der Rest
            widget.insertBefore(content, toggle);
            toggle.removeEventListener('click', onToggle);
            toggle.remove();
            while (body.firstChild) widget.appendChild(body.firstChild);
            body.remove();

            toggle = null;
            body   = null;
        }

        const apply = () => (mq.matches ? build() : teardown());

        apply();
        mq.addEventListener('change', apply);
    });
}
